import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Accordion, AccordionSummary, AccordionDetails, Typography } from "@mui/material";
import "./Demo.scss";
import about_ko from "../about/json/about_ko.json";
import about_en from "../about/json/about_en.json";

function Demo() {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const about_data = lang === "en" ? about_en : about_ko;
  const { main_title, navbar_links, sub_titles, intro_pars, faqs } = about_data;

  const navigate = useNavigate();
  const [about, setAbout] = useState(false);
  const { t } = useTranslation();

  return (
    <div className="about-root">
      <div className="about-header">
        <div className="about-header-title">{main_title}</div>
        <div className="about-header-links">
          <div className="about-header-link" onClick={() => navigate("/")}>
            {navbar_links[0]}
          </div>
          <div
            className="about-header-link"
            onClick={() => {
              return;
            }}
          >
            {t("demo")}
          </div>
          <div className="about-header-link" onClick={() => navigate("/about")}>
            {navbar_links[2]}
          </div>
        </div>
      </div>
      <div className="about-body">
        <div className="about-body-game">
          <div className="about-body-game-title">{t("demo")}</div>
          <div className="about-body-game-text">
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/yaosUp5n8eU"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Demo;
